import { render, staticRenderFns } from "./AnzeraChatBot.vue?vue&type=template&id=d8cac50a&scoped=true"
import script from "./AnzeraChatBot.vue?vue&type=script&lang=js"
export * from "./AnzeraChatBot.vue?vue&type=script&lang=js"
import style0 from "./AnzeraChatBot.vue?vue&type=style&index=0&id=d8cac50a&prod&scoped=true&lang=css"
import style1 from "./AnzeraChatBot.vue?vue&type=style&index=1&id=d8cac50a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cac50a",
  null
  
)

export default component.exports